// extracted by mini-css-extract-plugin
module.exports = {"list":"SecureSales_list__zzryj"};